// src/pages/CustomerMapPage.js
import React, { useState, useEffect } from "react";
import { Layout } from "../components/Layout";
import Breadcrumb from "../components/Breadcrumb";
import { getCustomersWithOpenPendings } from "../services/customerService";
import { Container, Title } from "../styles/StyledComponents";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "calc(100vh - 110px)" // Ajuste conforme necessário para ocupar o espaço até a base da página
};

const center = { lat: -23.55052, lng: -46.633308 };

const mapOptions = {
  styles: [
    { stylers: [{ saturation: -100 }, { gamma: 1 }] },
    { elementType: "labels.text.stroke", stylers: [{ visibility: "off" }] },
    { featureType: "poi.business", elementType: "labels.text", stylers: [{ visibility: "off" }] },
    { featureType: "poi.business", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "poi.place_of_worship", elementType: "labels.text", stylers: [{ visibility: "off" }] },
    { featureType: "poi.place_of_worship", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ visibility: "simplified" }] },
    { featureType: "water", stylers: [{ visibility: "on" }, { saturation: 50 }, { gamma: 0 }, { hue: "#50a5d1" }] },
    { featureType: "administrative.neighborhood", elementType: "labels.text.fill", stylers: [{ color: "#333333" }] },
    { featureType: "road.local", elementType: "labels.text", stylers: [{ weight: 0.5 }, { color: "#333333" }] },
    { featureType: "transit.station", elementType: "labels.icon", stylers: [{ gamma: 1 }, { saturation: 50 }] }
  ]
};

const CustomerMapPage = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const data = await getCustomersWithOpenPendings();
        setCustomers(data);
      } catch (error) {
        console.error("Erro ao carregar clientes:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Função para definir o ícone do marcador com base nas pendências abertas
  const getIconUrl = (customer) => {
    // ícone padrão
    let iconUrl = "/icons/a-green.png";
  
    if (customer.equipment && customer.equipment.length > 0) {
      for (const eq of customer.equipment) {
        if (eq.openPendencias && eq.openPendencias.length > 0) {
          // Procura por pendências em que o equipamento está "Parado"
          for (const pendencia of eq.openPendencias) {
            if (pendencia.situacaoEquipamento === "Parado") {
              switch (pendencia.statusPendencia) {
                case "Nova":
                  iconUrl = "/icons/a-red.png";
                  break;
                case "Aguardando Orçamento":
                  iconUrl = "/icons/b-red.png";
                  break;
                
                  case "Aguardando Aprovação":
                    iconUrl = "/icons/c-red.png";
                    break;
                  // Adicione outros cases conforme necessário
                default:
                  // Caso queira definir um padrão para outros status
                  iconUrl = "/icons/a-red.png";
              }
              // Encerra a iteração assim que encontra uma pendência que atende à condição
              break;
            }

            if (pendencia.situacaoEquipamento === "Funcionando") {
              switch (pendencia.statusPendencia) {
                case "Nova":
                  iconUrl = "/icons/a-yellow.png";
                  break;
                case "Aguardando Orçamento":
                  iconUrl = "/icons/b-yellow.png";
                  break;
                
                  case "Aguardando Aprovação":
                    iconUrl = "/icons/c-yellow.png";
                    break;
                  // Adicione outros cases conforme necessário
                default:
                  // Caso queira definir um padrão para outros status
                  iconUrl = "/icons/a-yellow.png";
              }
              // Encerra a iteração assim que encontra uma pendência que atende à condição
              break;
            }
          }
        }
      }
    }
  
    return iconUrl;
  };

  return (
    <Layout pageTitle="Mapa de Clientes">
      <Breadcrumb items={["Home", "Clientes", "Mapa de Clientes"]} />
      <Container>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          zoom={12}
          center={center}
          options={mapOptions}
        >
          {customers.map((customer) => {
            const lat = parseFloat(customer.latitude);
            const lng = parseFloat(customer.longitude);
            if (isNaN(lat) || isNaN(lng)) return null;

            const iconUrl = getIconUrl(customer);

            return (
              <Marker
                key={customer._id}
                position={{ lat, lng }}
                title={customer.name}
                icon={{
                  url: iconUrl,
                  scaledSize: { width: 32, height: 32 }
                }}
                onClick={() => setSelectedCustomer(customer)}
              />
            );
          })}


{selectedCustomer && (
  <InfoWindow
    position={{
      lat: parseFloat(selectedCustomer.latitude),
      lng: parseFloat(selectedCustomer.longitude)
    }}
    onCloseClick={() => setSelectedCustomer(null)}
  >
    <div style={{ maxWidth: "250px", fontSize: "12px", lineHeight: "1.2" }}>
      <h3 style={{ margin: "0 0 4px 0" }}>{selectedCustomer.name}</h3>
      <p style={{ margin: "2px 0" }}><strong>Status:</strong> {selectedCustomer.status}</p>
      <p style={{ margin: "2px 0" }}><strong>Tipo:</strong> {selectedCustomer.type}</p>
      <p style={{ margin: "2px 0" }}>
        <strong>Endereço:</strong> {selectedCustomer.address}, {selectedCustomer.number} - {selectedCustomer.neighborhood}
      </p>
      {selectedCustomer.contractNumber && (
        <p style={{ margin: "2px 0" }}><strong>Contrato:</strong> {selectedCustomer.contractNumber}</p>
      )}

      {selectedCustomer.equipment && selectedCustomer.equipment.length > 0 && (
        <>
          <p style={{ margin: "4px 0 2px 0" }}><strong>Equipamentos:</strong></p>
          <ul style={{ paddingLeft: "16px", margin: "0" }}>
            {selectedCustomer.equipment.map((eq, idx) => (
              <li key={idx} style={{ marginBottom: "4px", listStyleType: "disc" }}>
                {eq.equipmentNumber} - {eq.type} - {eq.manufacturer}
                {eq.openPendencias && eq.openPendencias.length > 0 && (
                  <ul style={{ paddingLeft: "12px", margin: "2px 0 0 0" }}>
                    {eq.openPendencias.map((pendencia, pidx) => (
                      <li key={pidx} style={{ margin: "2px 0", fontSize: "11px", listStyleType: "circle" }}>
                        <div style={{ backgroundColor: "#fff9c4", padding: "4px", borderRadius: "4px" }}>
                          <p style={{ margin: "1px 0" }}>
                            <strong>Descrição:</strong> {pendencia.descricaoPendencia}
                          </p>
                          <p style={{ margin: "1px 0" }}>
                            <strong>Situação:</strong> {pendencia.situacaoEquipamento}
                          </p>
                          <p style={{ margin: "1px 0" }}>
                            <strong>Status:</strong> {pendencia.statusPendencia}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  </InfoWindow>
)}


        </GoogleMap>
      </Container>
    </Layout>
  );
};

export default CustomerMapPage;
